"use client";

import { queryKeys, useHQuery } from "@highway/design-system";
import { IBrandingOption } from "@highway/mbs-shared";
import { useSearchParams } from "next/navigation";
import { ISocialShareItem } from "../../../types/marketing";
import LiveShareLayout from "../../../components/LiveShareLayout/LiveShareLayout";

type TLiveShareData = {
    itemID: string;
    branding: IBrandingOption | null;
    tagline: string;
};

const LiveShare = () => {
    const searchParams = useSearchParams();
    const shareData = searchParams.get("share-data");

    const { data: liveShareData, isPending: liveSharePending } = useHQuery<TLiveShareData[]>({
        route: `/v1/share/live-share-auth?share-data=${shareData}`,
        keys: queryKeys.liveShare.auth(shareData ?? ""),
    });

    const { data: itemData, isPending: itemPending } = useHQuery<ISocialShareItem[]>({
        route: `/v1/social-share/${!liveSharePending ? liveShareData[0].itemID : ""}`,
        keys: queryKeys.liveShare.socialShareItem(!liveSharePending ? liveShareData[0].itemID : ""),
        enabled: !liveSharePending,
    });

    if (liveSharePending || itemPending || !liveShareData?.[0] || !itemData?.[0]) return <></>;

    const { branding, tagline } = liveShareData[0];
    const { caption, imgUrl } = itemData[0];

    return (
        <LiveShareLayout branding={branding} caption={caption} tagline={tagline}>
            <img
                src={imgUrl}
                alt="sharing-image"
                style={{
                    width: "100%",
                    borderRadius: "8px",
                    boxShadow: "0px 0px 24px 0px rgba(0, 0, 0, 0.25)",
                }}
            />
        </LiveShareLayout>
    );
};

export default LiveShare;
